// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2KQSK","col":"CardReaderDesc_col__1xWE0","label":"CardReaderDesc_label__G_BnS"};